import { authStoreType } from "../recoil/auth";
import {
  contentLangType,
  parentStoreSectorNameLangType,
  sectorNameLangType,
  titleLangType,
} from "../recoil/type";
import Axios, { Response } from "../utils/Axios";

export const CONTENT_STORE_TYPE = "STORE";
type ContentStoreStringType = "STORE";

export const CONTENT_SECTOR_TYPE = "SECTOR";
type ContentSectorStringType = "SECTOR";

export const CONTENT_CATEGORY_TYPE = "CATEGORY";
type ContentCategoryStringType = "CATEGORY";

export const CONTENT_CARD_TYPE = "CARD";
type ContentCardStringType = "CARD";

export const STORE_CLOSE = "close";
type StoreCloseType = "CLOSE";
export const STORE_OPEN = "open";
type StoreOpenType = "OPEN";
export const STORE_PAUSE = "pause";
type StorePauseType = "PAUSE";

export type WebStoreSelectorType = {
  owner_section: OwnerSectionType[];
  main_section: MainSectionType[];
  adver_section: AdverSectionType[];
  auth_section: authStoreType;
  event_section: EventType[];
  coupon_section: any;
};
// 광고, 이벤트
export type EventType = {
  event_id: number;
  event_name: string;
  event_type: number;
  event_url: string;
  type: string;
  used: number;
};
export type AdvertisementType = {
  adver_media_id: number;
  store_id: number;
  store_name: string;
  file_name: string;
  url_path: string;
  mime_type: string;
  file_size: number;
  action_type: number | null;
  action_url: string | null;
  confirm_status: number;
  confirm_detail: number;
  confirmed_at: string;
  view_type: number;
  id_order: number;
  type: string;
  full_path?: string;
};

export type OwnerSectionType = {
  content_name: string;
  content: ContentType[];
};

export type MainSectionType = {
  content_name: string;
  content: ContentType[];
};

export type AdverSectionType = {
  adver_media_id: number;
  store_id: number;
  store_name: string;
  file_name: string;
  url_path: string;
  mime_type: string;
  type: number;
  file_size: number;
  action_type: number;
  action_url: string | null;
  confirm_status: number;
  confirm_detail: string | null;
  confirmed_at: string | null;
  view_type: number;
  id_order: number;
};

export type ContentCategoryDataType = {
  store_id: number;
  category_id: number;
  category_name: string;
  category_url: string | null;
};

export type ContentType =
  | ContentSectorType
  | ContentStoreType
  | ContentCategoryType
  | ContentCardType;

export type ContentSectorType = {
  content_type: ContentSectorStringType;
  data: ContentSectorDataType;
};

export type ContentStoreType = {
  content_type: ContentStoreStringType;
  data: ContentStoreDataType;
};

export type ContentCategoryType = {
  content_type: ContentCategoryStringType;
  data: ContentCategoryDataType;
};
export type ContentCardType = {
  content_type: ContentCardStringType;
  data: ContentCardDataType;
};
export type ContentCardDetailType = {
  card_id: number;
  content_data: CardDetailContentType[];
  voucher: VoucherType;
};
export type CardDetailContentType = {
  content_id: number;
  card_id: number;
  content_type: number;
  content_translate_id: number | null;
  url: string;
  id_order: number;
  content: string | null;
};
export type VoucherType = {
  voucher_id: number;
  benefit: string;
  benefit_en: string;
  phone_number: string;
  address: string;
  address_en: string;
  store_name: string;
  store_name_en: string;
  map_link: string;
  comment: string;
};

export type ContentCardDataType = titleLangType & {
  title: string;
  card_type: number;
  card_id: number;
  url: string;
  card_content: (contentLangType & {
    content_type: number;
    content: string;
    content_id_order: number;
    url: string;
  })[];
};
export type ContentSectorDataType = ContentInfoSectorType & {
  store_list: ContentStoreDataType[];
};

export type ContentStoreDataType = ContentInfoStoreType &
  ContentInfoOpenCloseType &
  ContentInfoCouponType &
  ContentInfoSectorType &
  ContentInfoDeliveryType &
  ContentInfoEtcType;

export type ContentInfoStoreType = {
  store_id: number;
  store_name: string; //호랑이반점
  store_name_en: string; //호랑이반점
  store_img_url: string;
};

export type ContentInfoDeliveryType = {
  base_delivery_price: number;
  delivery_estimated_time: number;
};

export type ContentInfoEtcType = {
  order_count: number;
  rating: number;
  ad_started_at: string;
};

export type ContentInfoOpenCloseType = {
  next_open_time: Date | string; //2023-05-09T15:00:00.000Z
  next_close_time: Date | string; //2023-05-09T15:00:00.000Z
  store_availability_yn: boolean;
  store_availability: string; //open , pause, close
};

export type ContentInfoCouponType = {
  coupon_yn: boolean;
  coupon_badge_name: string | null; //coupon_yn===true일 경우 뱃지 워딩 "쿠폰"
};

export type ContentInfoSectorType = sectorNameLangType &
  parentStoreSectorNameLangType & {
    sector_id: number;
    sector_name: string;
    sector_url: string | null;
    parent_store_sector_id: number;
    parent_store_sector_name: string;
  };

export type AreaType = {
  area_name: string;
  area_number: number;
  room_list: RoomType[];
};

export type RoomType = {
  name: string;
  number: number;
};
